var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00279 0C5.96333 0 4.31002 1.65331 4.31002 3.69277V6.15582H3.07629C2.16986 6.15582 1.43506 6.89062 1.43506 7.79705V14.3588C1.43506 15.2652 2.16986 16 3.07629 16H12.9237C13.8301 16 14.5649 15.2652 14.5649 14.3588V7.79705C14.5649 6.89062 13.8301 6.15582 12.9237 6.15582H11.6956V3.69277C11.6956 1.65331 10.0422 0 8.00279 0ZM10.8749 6.15582V3.69277C10.8749 2.10652 9.58903 0.820616 8.00279 0.820616C6.41654 0.820616 5.13063 2.10652 5.13063 3.69277V6.15582H10.8749ZM3.07629 6.97643H12.9237C13.3769 6.97643 13.7443 7.34384 13.7443 7.79705V14.3588C13.7443 14.812 13.3769 15.1794 12.9237 15.1794H3.07629C2.62308 15.1794 2.25567 14.812 2.25567 14.3588V7.79705C2.25567 7.34384 2.62308 6.97643 3.07629 6.97643Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOutline);
export default __webpack_public_path__ + "static/media/lock-outline.3911298b94111ec6c9bdcc3a04d85d0f.svg";
export { ForwardRef as ReactComponent };